import { createSlice, SliceCaseReducers } from "@reduxjs/toolkit";
import { FileType, StockHoldingFileType } from "operations/schema/schema"; 
import { RootState } from "store";
import { asyncQueries, queryBuilder } from "./files.queries";

export interface State {
  files: FileType[];
  stockHoldingFiles: StockHoldingFileType[];
  loadingFiles: boolean;
  customerFiles: FileType[];
  loadingCustomerFiles: boolean;
}

interface Actions extends SliceCaseReducers<State> {}

interface Selectors {
  selectFiles: (state: RootState) => FileType[];
  selectStockHoldingFiles: (state: RootState) => StockHoldingFileType[];
  selectCustomerFiles: (state: RootState) => FileType[];
  selectLoadingCustomerFiles: (state: RootState) => boolean;
}

export const initialState: State = {
  files: [],
  stockHoldingFiles: [],
  loadingFiles: false,
  customerFiles: [],
  loadingCustomerFiles: false,
};

const actions: Actions = {};

const selectors: Selectors = {
  selectFiles(state: RootState) {
    return state.files.files;
  },
  selectStockHoldingFiles(state: RootState) {
    return state.files.stockHoldingFiles;
  },
  selectCustomerFiles(state: RootState) {
    return state.files.customerFiles;
  },
  selectLoadingCustomerFiles(state: RootState) {
    return state.files.loadingCustomerFiles;
  },
};

const storeBase = createSlice<State, Actions>({
  name: "files",
  initialState,
  reducers: actions,
  extraReducers: queryBuilder,
});

export default storeBase.reducer;
export const {
  selectFiles,
  selectStockHoldingFiles,
  selectCustomerFiles,
  selectLoadingCustomerFiles,
} = selectors;
export const { getStockHoldingFiles, getCustomerFiles } = asyncQueries;